import { motion } from "framer-motion";

const messages = [
  { app: "Slack", message: "'Can you hop on a quick call?'", type: "message" },
  { app: "Zoom", message: "Meeting starting in 5 mins...", type: "notification" },
  { app: "iMessage", message: "'Hey, we need to talk.'", type: "message" },
  { app: "Gmail", message: "10 mins until your therapy session", type: "notification" }
];

const FlowingText = () => {
  // Offsets relative to the center line
  const offsets = [
    { x: -40, rotate: -6 },
    { x: 40, rotate: 6 },
    { x: -30, rotate: -4 },
    { x: 30, rotate: 4 }
  ];

  return (
    <div className="w-full bg-background py-24 overflow-hidden">
      <div className="container px-4 mx-auto">
        <div className="flex flex-col items-center justify-center gap-12 tablet:gap-16 laptop:gap-16 desktop:gap-16">
          {messages.map((msg, i) => (
            <motion.div
              key={msg.app}
              initial={{ opacity: 0, scale: 0.8, y: 20 }}
              whileInView={{ opacity: 1, scale: 1, y: 0 }}
              transition={{ delay: i * 0.1, duration: 0.5, type: "spring" }}
              viewport={{ once: false, amount: 0.5 }}
              className="relative w-full max-w-[280px] tablet:max-w-[320px] laptop:max-w-[320px] desktop:max-w-[320px]"
              style={{
                translateX: offsets[i].x,
                rotate: offsets[i].rotate
              }}
            >
              <div className="bg-white p-6 rounded-2xl shadow-[0_8px_30px_rgb(0,0,0,0.08)] border border-foreground/5 hover:shadow-[0_8px_30px_rgb(0,0,0,0.12)] transition-shadow duration-300">
                <div className="flex items-center justify-between mb-3">
                  <p className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">{msg.app}</p>
                </div>
                <p className="text-base font-medium text-foreground leading-snug font-sans">{msg.message}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FlowingText;
